export default __webpack_public_path__ + "static/media/home-design-agency-img-10.4b3af6b6.jpg";